import { Types } from 'mongoose';

import { COVER_NOTES_STATE } from '@shared/constants';

import { IAttachmentDocument, IBaseEntity } from '../common';

export interface IBasicInfo {
  businessRegNumber: string;
  nationalIdentityCardPassport: string;
  remarks: string;
}

export interface IRiskInfo {
  vehicleType: string;
  purchaseValue: number;
  sumAssured: number;
  premiumExcludingTaxes: number;
  premiumIncludingTaxes: number;
  vehicleRegisterNumber: string;
  make: string;
  distinctiveNumber: string;
  engineNumber: string;
  chassisNumber: string;
}

export interface ICoverNoteCreation extends IBaseEntity {
  state: COVER_NOTES_STATE;
  policyId: Types.ObjectId | string;
  leadId: Types.ObjectId | string;
  requestNumber?: string;
  isIndividual: boolean;
  nationalIdentityCardPassport: string;
  businessRegNumber: string;
  remarks: string;
  vehicleType: string;
  purchaseValue: number;
  sumAssured: number;
  premiumExcludingTaxes: number;
  premiumIncludingTaxes: number;
  vehicleRegisterNumber: string;
  make: string;
  distinctiveNumber: string;
  engineNumber: string;
  chassisNumber: string;
  tenant?: Types.ObjectId | string;
  coverNoteNumber?: string;
  validFrom?: Date;
  validTo?: Date;
  documents?: IAttachmentDocument;
  issuedOn?: Date;
  issuedBy?: Types.ObjectId | string;
  cancelRemark?: string;
  cancelBy?: Types.ObjectId | string;
  cancelOn?: Date;
}

export interface ICoverNoteResponse extends ICoverNoteCreation {
  // system_data: IExternalSystem;

  issued_on: Date;
  issued_by: Types.ObjectId | string;
  created_by: Types.ObjectId | string;
  // last_modifications: ILog[];
  // first_modification: ILog;
  // changed_by?: string | Types.ObjectId;
}

export interface IIssueCoverNote {
  coverNoteNumber: string;
  validFrom: Date;
  validTo: Date;
  documents: IAttachmentDocument[];
  leadId: string;
}

export enum COVER_NOTES_REFERENCE_SECTION {
  COVER_NOTES = 'Cover-notes',
}

export enum COVER_NOTES_REFERENCE_CATEGORIES {
  VEHICLES = 'Vehicles',
}

export enum COVER_NOTES_REFERENCE_CATEGORY_FIELD {
  NAME = 'Name',
}
